import { BIG_COMMERCE, WOO_COMMERCE } from 'constants/platform';

export const isGooglePlatformSupported = (shopType) => ![WOO_COMMERCE, BIG_COMMERCE].includes(shopType);
